<template src="./occurrenceReport.pug" lang="pug"></template>

<script>

import MultiSelectModal from '../../../modals/multiSelectModal/MultiSelectModal'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import FormSearch from '../../../form/formSearch/FormSearch'
import DateRange from '../../../input/dateRange/DateRange'
import BetterInputTag from '../../../input/betterInputTag/BetterInputTag'
import InputEstablishment from '../../../input/inputEstablishment/InputEstablishment'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import TreeGrid from '../../../treeGrid/TreeGrid'
import { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'
import language from '../../../../../build/language/index'
import { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'

export default {
  name: 'OccurrenceReport',

  components: {
    MultiSelectModal,
    PageTitle,
    FilterPortlet,
    FormSearch,
    DateRange,
    BetterInputTag,
    InputEstablishment,
    ButtonPrimary,
    TreeGrid
  },

  data () {
    return {
      establishimentsUrls: {
        establishments: 'occurrenceReport/establishment/list',
        attributes: '/occurrenceReport/loadEstablishmentAtt'
      },
      selectedEstablishments: [],
      isAdvancedSearch: true,
      gridId: '#occurrenceReportGrid',
      result: {},
      treeGridCfg: {},
      OCCURRENCES_MODAL: 'occurrencesModal',
      dateRange: {},
      itensSelected: [],
      list: [],
      selectedList: [],
      selectedStatuses: [],
      firstDate: new Date(),
      finalDate: new Date(),
      dataTableColumns: [],
      disableSearchButton: false,
      showTreegrid: false,
      exportUrl: EXPORT_TREEGRID,
      firstTime: true,
      titleModal: null,
      subTitleModal: null,
      columnsClasses: {},
      orderBy: {},
      headings: {},
      templates: {},
      customSorting: {},
      sortable: [],
      firstTimeOccurrence: true,
      selectDataTableCustomSetOrder: null,
      customTagMap: null,
      filterable: [],
      attList: [],
      columnsFilterable: [],
      showCustomColumns: false,
      inputTagsProps: {
        occurrenceReason: {
          id: 'id',
          name: 'descricao'
        }
      },
      shown: {
        occurrenceReason: false
      },
      defaultTags: {
        occurrenceReason: [{
          id: '-1',
          descricao: this.$t('inputTag.labels.todos')
        }]
      },
      data: {
        occurrenceReason: {
          titles: {
            main: this.$t('relatorioOcorrencia.labels.motivoOcorrencia'),
            sub: this.$t('relatorioOcorrencia.labels.selecaoMotivoOcorrencia')
          },
          selectedItems: [],
          columns: ['codigo', 'descricao'],
          values: [],
          options: {
            columnsClasses: { codigo: 'col-md-4', descricao: 'col-md-8' },
            perPage: 5,
            headings: {
              codigo: this.$t('motivoOcorrencia.labels.sigla'),
              descricao: this.$t('motivoOcorrencia.labels.descricao')
            },
            filterable: ['codigo', 'descricao'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['codigo', 'descricao'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'codigo'
            },
            customSorting: {
              codigo: function (asc) {
                return function (a, b) {
                  if (asc) {
                    return a.codigo.toLowerCase().localeCompare(b.codigo.toLowerCase())
                  }
                  return b.codigo.toLowerCase().localeCompare(a.codigo.toLowerCase())
                }
              },
              descricao: function (asc) {
                return function (a, b) {
                  if (asc) {
                    return a.descricao.toLowerCase().localeCompare(b.descricao.toLowerCase())
                  }
                  return b.descricao.toLowerCase().localeCompare(a.descricao.toLowerCase())
                }
              }
            }
          }
        }
      }
    }
  },

  computed: {
    idsFilterEstablishments () {
      return this.$store.getters.idsFilterEstablishments
    }
  },

  methods: {
    resetFilter () {
      this.selectedEstablishments = []
      this.data.occurrenceReason.selectedItems = []
    },

    validate () {
      let self = this
      return new Promise(resolve => {
        this.$validator.validateAll().then((result) => {
          if (result && this.$refs.dateRange.validate()) {
            this.showTreegrid = true
            startTreeGridLoading(self.gridId)
            this.search().finally(() => {
              resolve()
            })
          } else {
            resolve()
          }
        })
      })
    },

    search () {
      this.disableSearchButton = true
      let inicio = this.dateRange.fromDate
      let fim = this.dateRange.toDate
      let filter = {
        inicio: inicio,
        fim: fim,
        idsMotivosOcorrencias: this.data.occurrenceReason.selectedItems.map(selected => selected.id).filter(occurrence => occurrence !== '-1'),
        idsEstabelecimentos: this.selectedEstablishments.map(selected => selected.id),
        idsPlanosConciliacao: [], // this.plansSelected.map(plan => plan['id']),
        lang: language.getCookieByName('language')
      }
      return new Promise((resolve, reject) => {
        this.$store.dispatch('searchOccurrenceReport', filter)
          .then((response) => {
            window.DisposeGrids()
            this.treeGridCfg = response.data.Cfg.Layout
            this.result = response.data
            stopTreeGridLoading(this.gridId)
            this.disableSearchButton = false
            resolve()
          }).catch((error) => {
            this.$root.$refs.notification.error(error)
            stopTreeGridLoading(this.gridId)
            this.disableSearchButton = false
            reject()
          })
      })
    },

    openSelectOccurrencesModal () {
      if (this.data.occurrenceReason.values.length > 0) {
        this.shown.occurrenceReason = true
        return
      }
      this.$store.dispatch('getOccurrenceReasons', '/occurrenceReport/occurrenceReason/list').then((response) => {
        this.data.occurrenceReason.values = response.data.data
        this.shown.occurrenceReason = true
      })
    },

    closeModal () {
      this.shown.occurrenceReason = false
    }
  },

  created () {
    this.$store.dispatch('cleanEditState')
  }
}
</script>

<style>
@import '../../../../../node_modules/vue-nav-tabs/themes/vue-tabs.css';
#tab-navigation {
  font-family: 'Inter', sans-serif;
}

.tab {
  margin-top: 20px;
}

.nav-tabs>li>a {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  text-transform: none;
}

.vue-tabs .nav>li span.title {
  color: #142C4F;
}

.vue-tabs .nav-tabs {
  border-bottom: 1px solid #e1e1e1;
}

.vue-tabs .nav-tabs>li>a {
  border: none;
}

.vue-tabs .nav>li.active span.title {
  color: #142C4F;
}

.vue-tabs .nav-tabs>li.active>a,
.vue-tabs .nav-tabs>li.active>a:hover,
.vue-tabs .nav-tabs>li.active>a:focus {
  border: none;
  border-top: 5px solid #142C4F;
  color: #142C4F;
  background: #fff;
  font-weight: 600;
  margin-bottom: -1px;
  padding-bottom: 11px;
}

.vue-tabs .nav-tabs>li>a,
.vue-tabs .nav-tabs>li>a:hover,
.vue-tabs .nav-tabs>li>a:focus {
  border: none;
  border: 1px solid #e1e1e1;
  color: #142C4F;
  background: transparent;
  font-weight: 600;
  margin-bottom: -1px;
  padding-bottom: 13px;
}

.tab-content {
  background: #fff;
}

.pending-title {
  text-align: center;
  font-weight: bold;
  font-family: 'Inter', sans-serif;
  margin-top: 3vh;
  color: #17375f;
}

.grey-right-border {
  border-right: solid 2px #cccccc;
}

.pending-box {
  padding-right: 25px!important;
}

.pending-conciliation-box {
  display: grid;
}

.centered {
  text-align: center;
}

.badge-custom {
  padding: 7px 2px;
  margin-left: 1vh;
  background-color: #f55753 !important;
  border-radius: 50%;
  min-width: 30px;
  margin-top: 21px;
  right: 2px;
  z-index: 9;
  position: absolute;
}

p.placeholderInputTag {
  z-index:3;
  position:absolute;
  padding: 7px 0px 0px 7px;
  color: #999;
}

button.filter-input-tag {
  width: 100%;
  min-width:auto;
  padding:0px;
}
</style>



// WEBPACK FOOTER //
// OccurrenceReport.vue?a8bd09d6